import { render, staticRenderFns } from "./AssignmentUpload.vue?vue&type=template&id=6b6f998d&scoped=true&"
import script from "./AssignmentUpload.vue?vue&type=script&lang=js&"
export * from "./AssignmentUpload.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentUpload.vue?vue&type=style&index=0&id=6b6f998d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f998d",
  null
  
)

export default component.exports